import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export type IconSuspendedEvProps = {
    color?: string
    height?: number
    width?: number
    className?: ClassName
    style?: React.CSSProperties
}

export const IconSuspendedEv = React.memo(function IconSuspendedEv({
    color = '#2277DD',
    width = 57,
    height = 36,
    className,
    style,
}: IconSuspendedEvProps): React.ReactElement {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 57 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            style={style}
            data-testid="icon-suspended-ev"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0 1C0 0.447716 0.447715 0 1 0H11C11.5523 0 12 0.447715 12 1V35C12 35.5523 11.5523 36 11 36H1C0.447715 36 0 35.5523 0 35V1ZM33 30.125H45.3125V32.0625C45.3125 34.2371 47.0754 36 49.25 36C51.4247 36 53.1875 34.2371 53.1875 32.0625V30.125H56.5625V17.625C56.5625 15.9681 55.2194 14.625 53.5625 14.625H50.9375L48.4569 3.87573C47.9333 1.60706 45.9132 0 43.585 0H33V5.625H43.0625L45.3125 14.625H33V30.125ZM49.25 25.875C51.4247 25.875 53.1875 24.1121 53.1875 21.9375C53.1875 19.7629 51.4247 18 49.25 18C47.0754 18 45.3125 19.7629 45.3125 21.9375C45.3125 24.1121 47.0754 25.875 49.25 25.875ZM17 0C16.4477 0 16 0.447716 16 1V35C16 35.5523 16.4477 36 17 36H27C27.5523 36 28 35.5523 28 35V1C28 0.447715 27.5523 0 27 0H17Z"
                fill={color}
            />
        </svg>
    )
})
